import { RequiredFieldIndicator } from "@/components/forms/field-label";
import { Text } from "@/components/ui/text";

interface StepHeaderProps {
  title: string;
  description: string;
  required?: boolean;
}

function StepHeader({ title, description, required }: StepHeaderProps) {
  return (
    <div className="space-y-2">
      <div className="flex items-baseline gap-1">
        <Text as="h1" variant="h3" className="text-ink">
          {title}
        </Text>
        {required && <RequiredFieldIndicator label={title} />}
      </div>
      <Text variant="body" className="text-slate">
        {description}
      </Text>
    </div>
  );
}

export { StepHeader };
